import React from 'react';
import {useNavigate} from 'react-router-dom';
import { AdminModal, CreateTeamMemberPanel } from '../../../components';

function CreateTeamMember() {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate(-1);
    };

    return (
        <>
        <AdminModal open={true} onClose={handleClose}>
            <CreateTeamMemberPanel onClose={handleClose} />
        </AdminModal>
        </>

    )
}

export default CreateTeamMember